import type { SettingsMenuFragment } from './settings-menu.model';

export enum EFinancialIds {
  CHART_OF_ACCOUNTS = 'chart-of-accounts',
  CHART_OF_ACCOUNTS_TREE = 'chart-of-accounts-tree',
  CARD_AGREEMENTS = 'card-agreements',
  DISCOUNTS = 'discounts',
  BANK_ACCOUNTS = 'bank-accounts',
  FINES = 'fines',
  CAIXAS = 'caixas',
  RECONCILIATION_PROVIDERS = 'reconciliation-providers',
  RECONCILIATION_CONNECTIONS = 'reconciliation-connections',
}

export const financialPageFragments: SettingsMenuFragment[] = [
  {
    title: 'FINANCIAL.CHART_OF_ACCOUNTS.CHART_OF_ACCOUNTS',
    id: EFinancialIds.CHART_OF_ACCOUNTS,
  },
  {
    title: 'FINANCIAL.CARD_AGREEMENTS.CARD_AGREEMENTS',
    id: EFinancialIds.CARD_AGREEMENTS,
  },
  {
    title: 'FINANCIAL.DISCOUNTS.DISCOUNTS',
    id: EFinancialIds.DISCOUNTS,
  },
  // {
  //   title: 'FINANCIAL.BANK_ACCOUNTS.BANK_ACCOUNTS',
  //   id: EFinancialIds.BANK_ACCOUNTS,
  // },
  {
    title: 'FINANCIAL.FINES.FINES',
    id: EFinancialIds.FINES,
  },
  // {
  //   title: 'TREASURY.CHART_OF_ACCOUNTS.MENU_LABEL',
  //   id: EFinancialIds.CHART_OF_ACCOUNTS_TREE,
  //   treasuryFullEnabledTenantOnly: true,
  // },
  {
    title: 'FINANCIAL.CAIXAS.CAIXAS',
    id: EFinancialIds.CAIXAS,
    treasuryFullEnabledTenantOnly: true,
  },
  {
    title: 'RECONCILIATION.PROVIDERS.TITLE',
    id: EFinancialIds.RECONCILIATION_PROVIDERS,
    treasuryFullEnabledTenantOnly: true,
    adminScopeOnly: true,
  },
  {
    title: 'RECONCILIATION.CONNECTIONS.TITLE',
    id: EFinancialIds.RECONCILIATION_CONNECTIONS,
    treasuryFullEnabledTenantOnly: true,
  },
];
